import {TimelineType} from '../../models/enums/timeline';

export default function getIconName(type) {
  let icon;

  switch (type) {
    case TimelineType.FollowUpDismissed:
      icon = 'DeleteFollowUp';
      break;
    case TimelineType.FollowUpAddedAlexProScript:
    case TimelineType.FollowUpAddedAlexDesktopScript:
    case TimelineType.FollowUpAdded: // doesnt exist?
      icon = 'FollowUpPhoneCall';
      break;
    case TimelineType.FollowUpDeleted:
      icon = 'DeleteFollowUp';
      break;
    case TimelineType.FollowUpPhoneCall:
      icon = 'FollowUpPhoneCall';
      break;
    case TimelineType.CustomerVerifyAddress:
      icon = 'VerifyAddress';
      break;
    case TimelineType.SourceWaterUpdated:
    case TimelineType.SystemAnalysisUpdated:
      icon = 'EditSystemAnalysis';
      break;
    case TimelineType.AnalysisAddedAlexProScript:
    case TimelineType.AnalysisAddedAlexDesktopScript:
    case TimelineType.SourceWaterTested:
    case TimelineType.PoolOpened:
    case TimelineType.PoolClosed:
    case TimelineType.SystemAnalysisAdded:
      icon = 'AddSystemAnalysis';
      break;
    case TimelineType.SystemAnalysisDeleted: //doesnt exists?
      icon = 'EditSystemAnalysis';
      break;
    case TimelineType.CustomerNoteScript:
    case TimelineType.AccountNoteAdded:
      icon = 'AddCustomerNote';
      break;
    case TimelineType.AccountNoteDeleted:
      icon = 'DeleteCustomerNote';
      break;
    case TimelineType.AccountNoteUpdated:
      icon = 'EditCustomerNote';
      break;
    case TimelineType.CustomerAddedAlexProScript:
    case TimelineType.CustomerAddedAlexDesktopScript:
    case TimelineType.AccountAdded:
      icon = 'AddCustomer';
      break;
    case TimelineType.AccountStarred:
    case TimelineType.AccountUpdated:
      icon = 'EditCustomer';
      break;
    case TimelineType.AccountDeleted:
      icon = 'DeleteCustomer';
      break;
    case TimelineType.SystemNoteScript:
    case TimelineType.SystemNoteAdded:
      icon = 'AddSystemNote';
      break;
    case TimelineType.SystemNoteDeleted:
      icon = 'DeleteSystemNote';
      break;
    case TimelineType.SystemNoteUpdated:
      icon = 'EditSystemNote';
      break;
    case TimelineType.CustomerContactScript:
    case TimelineType.ContactAdded:
      icon = 'AddCustomerContact';
      break;
    case TimelineType.ContactDeleted:
      icon = 'DeleteCustomerContact';
      break;
    case TimelineType.ContactUpdated:
      icon = 'EditCustomerContact';
      break;
    case TimelineType.SystemAddedAlexProScript:
    case TimelineType.SystemAddedAlexDesktopScript:
    case TimelineType.SystemAdded:
      icon = 'AddSystem';
      break;
    case TimelineType.SystemDeleted:
      icon = 'DeleteSystem';
      break;
    case TimelineType.SeasonUsageUpdated:
    case TimelineType.BecameTruBlu:
    case TimelineType.RemovedTruBlu:
    case TimelineType.SystemUpdated:
      icon = 'EditSystem';
      break;
    case TimelineType.SystemMerge:
      icon = 'MergeSystem';
      break;
    case TimelineType.SaveEmailPreferences: //doesnt exists?
    case TimelineType.AccountMergeInto:
    case TimelineType.CustomerMergeDeleted:
      icon = 'MergeCustomer';
      break;
    case TimelineType.AnalysisImportedScript:
    case TimelineType.AnalysisImported:
      icon = 'ImportAnalysis';
      break;
    case TimelineType.CustomerImportedScript:
    case TimelineType.CustomerImported:
      icon = 'ImportCustomer';
      break;
    case TimelineType.SystemImportedScript:
    case TimelineType.SystemImported:
      icon = 'ImportSystem';
      break;
    case TimelineType.ReportHistoryEmail:
    case TimelineType.SeasonUsageEmail:
    case TimelineType.AnalysisEmail:
    case TimelineType.PastDueCustomerEmailed:
    case TimelineType.FollowUpEmailed:
    case TimelineType.WinterProductReminderEmailed:
    case TimelineType.InactiveCustomerEmailed:
    case TimelineType.WinterClosingEmailed:
    case TimelineType.DirectEmail:
    case TimelineType.EncyclopediaEmail:
    case TimelineType.WelcomeEmail:
      icon = 'AllEmailEvents';
      break;
    case TimelineType.FollowUpImportedScript:
      icon = 'ImportOther';
      break;
    case TimelineType.SourceConcern:
      icon = 'SourceConcern';
      break;
    case TimelineType.AccountEmailPref:
      icon = 'EmailOpt-out';
      break;
    case TimelineType.Anniversary:
      icon = 'AccountAnniversary';
      break;
    case TimelineType.AccountActivated: //missing
    case TimelineType.AccountDeactivated:
    case TimelineType.Product:
      icon = 'PurchaseMade';
      break;
    default:
      icon = 'AllOtherCustomerEvents';
  }
  return icon;
}
